import styled from "styled-components";

export default function SwitchMode({ toggleMode, mode }) {
  return (
    <SwitchModeContainer>
      <label className="mode-item" htmlFor="mode1">
        <input type="radio" name="mode" id="mode1" value={mode} onChange={() => toggleMode(true)} defaultChecked />
        <span>Mode 1</span>
      </label>
      <label className="mode-item" htmlFor="mode2">
        <input type="radio" name="mode" id="mode2" value={!mode} onChange={() => toggleMode(false)} />
        <span>Mode 2</span>
      </label>
    </SwitchModeContainer>
  );
}

const SwitchModeContainer = styled.div`
  display: flex;
  align-items: center;
  height: 25px;
  background-color: white;
  border-radius: 5px;
  font-size: 15px;

  label {
    flex: 1;
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
  }

  input {
    display: none;
  }

  label:has(input:checked) {
    font-weight: bold;
    background-color: #0f77ffff;
    color: white;
  }
`;
